"use client";

import { SignupFormProvider } from "@portal/app/context/signupFormProvider";

export default function Layout({
  children,
}: Readonly<{
  children: React.ReactNode;
}>) {
  return <SignupFormProvider>{children}</SignupFormProvider>;
}
